export enum ResponseStatusEnum {
  Error = 'error',
  Success = 'success',
  Idle = 'idle',
}
